import {combineReducers} from '@reduxjs/toolkit';
import delegates from './delegatesReducer';
import fileUpload from './fileUploadReducer';

export const defaultState = {
    delegates: {},
    fileUpload: {},
}

const appReducer = combineReducers({
    delegates: delegates,
    fileUpload,
})

const rootReducer = (state = defaultState, action) => {
    return appReducer(state, action)
}

export default rootReducer;
